import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToasterService } from 'angular2-toaster';
import axios from 'axios';
import {
  ACCESSIBLE_CHANNEL_TYPE_DEVICE,
  ENDPOINTS,
  USER_ROLES,
} from '../app.config';
import Utils from '../app.utilities';
import { CompanyService } from '../company.service';
import * as urlRegex from 'url-regex';
import { DevicesConfirmedUnconfirmedService } from '../devices-confirmed-unconfirmed.service';
import { Subscription } from "rxjs/Subscription";
import { UserInfoService } from '../shared/user-info.service';
import { TranslateService } from '@ngx-translate/core';

const utilities = new Utils();

@Component({
  selector: 'app-devices',
  templateUrl: './devices.component.html',
  styleUrls: ['./devices.component.css'],
  // Is already provided in ../app.module.ts
  //  but the UserInfoService, in the constructor, needs access to ActivatedRoute.params
  //  https://stackoverflow.com/questions/39977962/angular-2-0-2-activatedroute-is-empty-in-a-service
  providers: [UserInfoService]
})
export class DevicesComponent implements OnInit, OnDestroy {
  router: any;
  route: any;
  companyService: any;
  toaster: any;
  companyId: any;
  companyName: any;
  sub: any;
  userRole: any;
  confirmedDevices: any;
  unconfirmedDevices: any;
  devicesTotal: number;
  devicesPerPage: number;
  totalPages: number;
  currentPage: number;
  dropdownSettings: any;
  channelsList: any;
  currentPageUnconfirmedDevices: any;
  unconfirmedDevicesPerPage: any;
  unconfirmedDevicesTotal: any;
  totalPagesUnconfirmedDevices: any;
  filter: any;
  filterUnconfirmed: any;
  query: any;
  queryUnconfirmed: any;
  selectedChannels: any;
  searchChannelIds: any;
  searchChannels: any;
  pinToken: any;
  Math: Math;
  weather_url : string;
  temporary_weather_url : string;
  subscription: Subscription;
  statusCheckInterval;
  businesOwnerName : string;
  businessOwnerIdLocalStorage = localStorage.getItem('businessOwnerId');

  // Messages
  url_successfully_saved: string;
  url_was_not_saved: string;
  device_added_to_unauthorized_devices: string;
  error_added_to_unauthorized_devices: string;
  device_verified: string;
  error_confirming_device: string;
  device_deleted: string;
  error_device_deleted: string;

  constructor(
    route: ActivatedRoute,
    companyService: CompanyService,
    toaster: ToasterService,
    router: Router,
    private devicesConfirmedUnconfirmedService : DevicesConfirmedUnconfirmedService,
    private userInfoService : UserInfoService,
    private translate: TranslateService
  ) {
    this.router = router;
    this.route = route;
    this.companyService = companyService;
    this.toaster = toaster;
  }

  ngOnInit() {
    this.Math = Math;
    this.searchChannels = [];
    this.searchChannelIds = [];
    // Translations
    this.translate.stream('SHARED.SelectBox.select_channels').subscribe((res: string) => {
      this.dropdownSettings = {
        singleSelection: false,
        enableCheckAll: false,
        text: res,
        selectAllText: 'Select All',
        unSelectAllText: 'Remove All',
        enableSearchFilter: false,
        classes: 'item-separation c-token',
      };
    });
    this.query = '';
    this.queryUnconfirmed = '';
    this.filter = 0;
    this.filterUnconfirmed = 0;
    this.currentPageUnconfirmedDevices = 1;
    this.currentPage = 1;
    this.confirmedDevices = this.unconfirmedDevices = [];
    this.sub = this.route.params.subscribe(params => {
      this.companyId = params.companyId;
      this.companyService.setCompanyId(this.companyId);
      this.getUserInfo();
      this.getConfirmedDevices();
      this.getUnconfirmedDevices();
      this.getChannels();
    });
    this.subscription = this.devicesConfirmedUnconfirmedService.statusChange$.subscribe( status => {
      // at the bottom of this component only unconfirmed devices are added
      if(status == "unconfirmed"){
        // refresh the data
        // new unconfirmed device - meaning that a device has been unconfirmed from the component DevicesTable(../devices-table)
        this.getUnconfirmedDevices();
      }
    });
    this.startStatusCheckInterval();


    // Messages translations
    this.translate.stream('SHARED.Messages.url_successfully_saved').subscribe((res: string) => {
      this.url_successfully_saved = res;
    });
    this.translate.stream('SHARED.Messages.url_was_not_saved').subscribe((res: string) => {
      this.url_was_not_saved = res;
    });
    this.translate.stream('SHARED.Messages.device_added_to_unauthorized_devices').subscribe((res: string) => {
      this.device_added_to_unauthorized_devices = res;
    });
    this.translate.stream('SHARED.Messages.error_added_to_unauthorized_devices').subscribe((res: string) => {
      this.error_added_to_unauthorized_devices = res;
    });
    this.translate.stream('SHARED.Messages.device_verified').subscribe((res: string) => {
      this.device_verified = res;
    });
    this.translate.stream('SHARED.Messages.error_confirming_device').subscribe((res: string) => {
      this.error_confirming_device = res;
    });
    this.translate.stream('SHARED.Messages.device_deleted').subscribe((res: string) => {
      this.device_deleted = res;
    });
    this.translate.stream('SHARED.Messages.error_device_deleted').subscribe((res: string) => {
      this.error_device_deleted = res;
    });
  }

  ngOnDestroy(){
    this.subscription.unsubscribe();
    clearInterval(this.statusCheckInterval);
  }

  generateChannelsList(channels) {
    const channelsList = [];
    for (const item of channels) {
      channelsList.push({
        id: item.id,
        itemName: item.name,
      });
    }
    return channelsList;
  }

  getChannels() {
    const _self = this;
    axios
      .get(ENDPOINTS.GET_CHANNELS.replace(':companyId', _self.companyId))
      .then(response => {
        _self.channelsList = _self.generateChannelsList(response.data);
      });
  }

  generatePages() {
    if (!this.totalPages) {
      return [];
    }
    const arr = [];
    for (let i = 0; i < this.totalPages; i++) {
      arr.push(i + 1);
    }
    return arr;
  }

  generatePagesUnconfirmed() {
    if (!this.totalPagesUnconfirmedDevices) {
      return [];
    }
    const arr = [];
    for (let i = 0; i < this.totalPagesUnconfirmedDevices; i++) {
      arr.push(i + 1);
    }
    return arr;
  }

  getUserInfo() {
    const _self = this;

    this.userInfoService.getInformations()
    .subscribe( info => {
      _self.userRole         = info.userRole;
      _self.companyName      = info.companyName;
      _self.businesOwnerName = info.businesOwnerName;

      if (
        _self.userRole !== USER_ROLES.COMPANY_VIEWER &&
        _self.userRole !== USER_ROLES.COMPANY_EDITOR
      ) {
        _self.getCompanyInfo();
      }

    });
  }

  getCompanyInfo() {
    const _self = this;
    axios
      .get(ENDPOINTS.GET_COMPANIES + '/' + _self.companyId)
      .then(response => {
        if (_self.userRole === USER_ROLES.ADMINISTRATOR || _self.userRole === USER_ROLES.BUSINESS_OWNER
          || _self.userRole === USER_ROLES.COMPANY_ADMIN) {
          _self.pinToken = response.data['pin'];
        }
      });
  }

  initPagingVars(response) {
    const _self = this;
    _self.devicesTotal = parseInt(response.headers['total'], 10);
    _self.devicesPerPage = parseInt(response.headers['per-page'], 10);
    _self.totalPages = Math.floor(_self.devicesTotal % _self.devicesPerPage) ===
      0
      ? _self.devicesTotal / _self.devicesPerPage
      : Math.floor(_self.devicesTotal / _self.devicesPerPage) + 1;
  }

  initPagingUnconfirmedVars(response) {
    const _self = this;
    _self.unconfirmedDevicesTotal = parseInt(response.headers['total'], 10);
    _self.unconfirmedDevicesPerPage = parseInt(
      response.headers['per-page'],
      10,
    );
    _self.totalPagesUnconfirmedDevices = Math.floor(
      _self.unconfirmedDevicesTotal % _self.unconfirmedDevicesPerPage,
    ) === 0
      ? _self.unconfirmedDevicesTotal / _self.unconfirmedDevicesPerPage
      : Math.floor(
          _self.unconfirmedDevicesTotal / _self.unconfirmedDevicesPerPage,
        ) + 1;
  }

  generateFilter() {
    let params = '';
    if (this.filter === '1') {
      params = '&connected=true';
    }
    if (this.filter === '2') {
      params = '&enabled=true';
    }
    if (this.filter === '3') {
      params = '&connected=false';
    }
    if (this.filter === '4') {
      params = '&enabled=false';
    }
    if (this.query.length) {
      params += '&q=' + this.query;
    }
    if (this.searchChannelIds.length) {
      params += '&channel_ids=' + this.searchChannelIds.join(',');
    }
    return params;
  }

  generateUnconfirmedFilter() {
    let params = '';
    if (this.filterUnconfirmed === '1') {
      params = '&connected=true';
    }
    if (this.filterUnconfirmed === '2') {
      params = '&connected=false';
    }
    if (this.queryUnconfirmed.length) {
      params += '&q=' + this.queryUnconfirmed;
    }
    return params;
  }

  initRestartTime(devices) {
    for (const device of devices) {
      const time = device.restart_time
        ? device.restart_time.split(':')
        : ['00', '00'];
      device.restartHour = time[0];
      device.restartMinutes = time[1];
    }
  }

  getConfirmedDevices() {
    const _self = this;
    let url =
      ENDPOINTS.DEVICES.replace(':companyId', _self.companyId) +
      '?confirmed=true' +
      _self.generateFilter();
    axios.get(url).then(response => {
      _self.initPagingVars(response);
      url =
        ENDPOINTS.DEVICES.replace(':companyId', _self.companyId) +
        '?confirmed=true' +
        '&page=' +
        _self.currentPage +
        '&per_page=' +
        _self.devicesPerPage +
        _self.generateFilter();
      axios.get(url).then(responseWithPaging => {
        _self.confirmedDevices = responseWithPaging.data;
        _self.sortDevices(_self.confirmedDevices);
        _self.generateChannelForEachPlaylist(_self.confirmedDevices);
        _self.initDeviceRestartToggle(_self.confirmedDevices);
        _self.initRestartTime(_self.confirmedDevices);
      });
    });
  }

  getUnconfirmedDevices( isStatusCheck? ) {
    const _self = this;
    let _isStatusCheck = isStatusCheck;

    let url =
      ENDPOINTS.DEVICES.replace(':companyId', _self.companyId) +
      '?confirmed=false' +
      _self.generateUnconfirmedFilter();
    axios.get(url).then(response => {
      _self.initPagingUnconfirmedVars(response);
      url =
        ENDPOINTS.DEVICES.replace(':companyId', _self.companyId) +
        '?confirmed=false' +
        '&page=' +
        _self.currentPageUnconfirmedDevices +
        '&per_page=' +
        _self.unconfirmedDevicesPerPage +
        _self.generateUnconfirmedFilter();
      axios.get(url).then(responseWithPaging => {

        // Status check interval
        if(_isStatusCheck == 'only-status-check'){
          responseWithPaging.data.forEach( newUnconfirmedDevice => {
            _self.unconfirmedDevices.forEach( unconfirmedDevice => {
              if( newUnconfirmedDevice.id === unconfirmedDevice.id ){
                unconfirmedDevice.is_confirmed = newUnconfirmedDevice.is_confirmed;
                unconfirmedDevice.is_connected = newUnconfirmedDevice.is_connected;
                unconfirmedDevice.is_enabled = newUnconfirmedDevice.is_enabled;
              }
            });
          });
          return;
        }

        _self.unconfirmedDevices = responseWithPaging.data;
        _self.sortDevices(_self.unconfirmedDevices);
        _self.generateChannelForEachPlaylist(_self.unconfirmedDevices);
        _self.initDeviceRestartToggle(_self.unconfirmedDevices);
        _self.initRestartTime(_self.unconfirmedDevices);
      });
    });
  }

  onTimeChanged(device) {
    device.restart_time =
      device.restartHour + ':' + device.restartMinutes + ':00';
    this.updateDevice({
      id: device.id,
      restart_time: device.restart_time,
    });
  }

  loadUnconfirmed(page, isDisabled) {
    if (!isDisabled) {
      this.currentPageUnconfirmedDevices = page;
      this.getUnconfirmedDevices();
    }
  }

  loadConfirmed(page, isDisabled) {
    if (!isDisabled) {
      this.currentPage = page;
      this.getConfirmedDevices();
    }
  }

  updateDevice(device, updateType?) {
    let _self = this

    const deviceForUpdate = device,
          _updateType = updateType;

    if (device.restartDisabled) {
      deviceForUpdate.restart_time = null;
    }
    axios.patch(
      ENDPOINTS.DEVICES.replace(':companyId', this.companyId) + '/' + device.id,
      deviceForUpdate,
    )
    .then(
      response => {
        if(_updateType == 'weather-update'){
          _self.toaster.pop(
            'success',
            this.url_successfully_saved
          );
        }
      },
      error => {
        if(_updateType == 'weather-update'){
          _self.toaster.pop(
            'error',
            this.url_was_not_saved
          );
        }
      },
    );
  }

  editDevice(device) {
    this.router.navigate(['/device-edit/' + this.companyId + '/' + device.id]);
  }

  handleTableTime(time, value, device) {
    let parsedValue = parseInt(device[value], 10);
    if (time === 'hours') {
      if (isNaN(parsedValue)) {
        parsedValue = 8;
        device[value] = '08';
      }
      if (parsedValue < 10 && parsedValue >= 0) {
        device[value] = '0' + parsedValue.toString();
      }
      if (parsedValue < 0) {
        device[value] = '00';
      }
      if (parsedValue > 23) {
        device[value] = '23';
      }
    } else {
      if (isNaN(parsedValue)) {
        parsedValue = 0;
      }
      if (parsedValue < 10 && parsedValue >= 0) {
        device[value] = '0' + parsedValue.toString();
      }
      if (parsedValue < 0) {
        device[value] = '00';
      }
      if (parsedValue > 59) {
        device[value] = '59';
      }
    }
    device.restart_time =
      device.restartHour + ':' + device.restartMinutes + ':00';
  }

  unconfirmDevice(device) {
    const _self = this;
    axios
      .delete(
        ENDPOINTS.DEVICES.replace(':companyId', this.companyId) +
          '/' +
          device.id +
          '/unconfirm',
      )
      .then(
        response => {
          _self.toaster.pop(
            'success',
            this.device_added_to_unauthorized_devices,
          );
          _self.getConfirmedDevices();
          _self.getUnconfirmedDevices();
        },
        error => {
          _self.toaster.pop(
            'error',
            this.error_added_to_unauthorized_devices,
          );
        },
      );
  }

  initDeviceRestartToggle(devices) {
    for (const device of devices) {
      device.restartDisabled = device.restart_time === null;
    }
  }

  generateChannelForEachPlaylist(devices) {
    for (const device of devices) {
      device.selectedChannels = this.generateChannelsList(device.channels);
    }
  }

  onItemSelect(channel, device) {
    if (device) {
      axios.post(ENDPOINTS.CHANNEL_ACCESS, {
        accessible_id: device.id,
        accessible_type: ACCESSIBLE_CHANNEL_TYPE_DEVICE,
        channel_id: channel.id,
      });
    }
  }

  onItemDeSelect(channel, device) {
    if (device) {
      axios.delete(ENDPOINTS.CHANNEL_ACCESS, {
        data: {
          accessible_id: device.id,
          accessible_type: ACCESSIBLE_CHANNEL_TYPE_DEVICE,
          channel_id: channel.id,
        },
      });
    }
  }

  confirmDevice(device) {
    const _self = this;
    axios
      .put(
        ENDPOINTS.DEVICES.replace(':companyId', _self.companyId) +
          '/' +
          device.id +
          '/confirm',
      )
      .then(
        response => {
          _self.toaster.pop('success', this.device_verified);
          _self.getConfirmedDevices();
          _self.getUnconfirmedDevices();
          _self.devicesConfirmedUnconfirmedService.statusChange("confirmed");
        },
        error => {
          _self.toaster.pop('error', this.error_confirming_device);
        },
      );
  }

  deleteDevice(device) {
    const _self = this;
    axios
      .delete(
        ENDPOINTS.DEVICES.replace(':companyId', this.companyId) +
          '/' +
          device.id,
      )
      .then(
        response => {
          _self.getUnconfirmedDevices();
          _self.toaster.pop('success', this.device_deleted);
        },
        error => {
          _self.toaster.pop('error', this.error_device_deleted);
        },
      );
  }

  getPinToken() {
    const _self = this;
    axios.get(ENDPOINTS.PIN_TOKEN).then(response => {
      const pinCodes = response.data;
      for (const item of pinCodes) {
        if (item.name === _self.companyName) {
          _self.pinToken = item.pin;
        }
      }
    });
  }

  toggleSearchChannelIds(channel) {
    if (this.searchChannelIds.includes(channel.id)) {
      this.searchChannelIds.splice(
        this.searchChannelIds.indexOf(channel.id),
        1,
      );
    } else {
      this.searchChannelIds.push(channel.id);
    }
    this.getConfirmedDevices();
  }

  printPage() {
    window.print();
  }

  sortDevices(list) {
    list.sort((a, b) => {
      return a.id > b.id ? 1 : b.id > a.id ? -1 : 0;
    });
  }

  toggleRestartTime(device) {
    device.restart_time = device.restartDisabled
      ? null
      : device.restartHour + ':' + device.restartMinutes + ':00';
    this.updateDevice({
      id: device.id,
      restart_time: device.restart_time,
    });
  }

  deviceNameKeyDown(e: KeyboardEvent) {
    if (e.keyCode == 13 && !e.shiftKey) {
        // prevent default behavior
        e.preventDefault();
    }
  }
  isWeatherUrlInvalid(device){
    // NOTE: temporary_weather_url is set tot weather_url at the begining, inside ngOnInit() last line: 97
    let twu = device.temporary_weather_url;

    if( twu === undefined || twu === ""){
      return;
      // return false;
    } else {
      var result = urlRegex().test(twu);
      return !result; // negate
    }
  }


  // in order to recheck the status of each device
  // the status: "povezan" can be updated outside this UI
  startStatusCheckInterval(){
    this.statusCheckInterval = setInterval( () => {
        this.getUnconfirmedDevices("only-status-check");
    }, 10000);
  }

}



// WEBPACK FOOTER //
// /Users/mihagresak/Documents/git-projects/vintegras-angular-new-clean/src/app/devices/devices.component.ts